import { ItemParameter, ItemParameterDTO } from './itemParameter';

export class BgBomModel {
  public id: string | undefined;
  public Status: ModelAggregationStatus | undefined;
  public subDivision: string | undefined;
  public modelName: string | undefined;
  public model3dId: string | undefined;
  public cdFileUrl: string | undefined;
  public apsPresentationViews: ApsPresentationView[] | undefined;
  public filesFolderId?: string; // folder for file explorer
  public sdFileUrl: string | undefined;
  public hasOptions: boolean = false;
  public hasPrice: boolean = false;
  public bomPriceCatalogId: string | undefined;
  public bgCategories: BgBomCategory[] | undefined;

}

export class BgBomCategory {
  public name!: string;
  public order: number | undefined;
  public option: number | undefined;
  public optionName: string | undefined;
  public applicableOptions: string | undefined;
  public optionsAutoApply: boolean = false;
  public hasLevelGroupingDisplay!: boolean;
  public bgGroupedSubCategories: BgBomGroupedSubCategory[] | undefined;
}

export class BgBomGroupedSubCategory {
  public name: string | undefined;
  public bgSubCategories: BgBomSubCategory[] | undefined;
}

export class ApsPresentationView {
  public  viewName : string | undefined;
  public  presentaionViewName : string | undefined;
}


export class BgBomSubCategory {
  public name!: string;
  public order: number | undefined;
  public bgBomItems!: BgBomItem[];
  public combinedBgBomItems : CombinedBgBomItem[] | undefined;
  public path!: string;
}



export class BgBomItem {
  public id: string | undefined;
  public group: string | undefined;
  public itemName: string | undefined;
  public size: string | undefined;
  public material: string | undefined;
  public description: string | undefined;
  public manufacturer: string | undefined;
  public manufacturerModel: string | undefined;
  public modelQuantity: string | undefined;
  public modelQuantityDescription: string | undefined;
  public quantity: number | undefined;
  public wasteFactor: string | undefined;
  public quantityToOrder: number | string | undefined;
  public quantityToOrderDescription: string | undefined;
  public parameters: ItemParameter[] | undefined;
  public order: number | undefined;
  public itemBomType: BomType |  undefined;
  public isEditMode?: boolean;
  public showLoader?: boolean;
  public flatIndex?: number;
  //decimal Cost and total cost
  public cost?: number;
  public totalCost?: number;
  public parentId?: string;
 }


 export class BgBomItemDTO {
  public id: string | undefined;
  public parentId?: string;
  public order : number | undefined;
  public group: string | undefined;
  public itemName: string | undefined;
  public size: string | undefined;
  public itemBomType: BomType |  undefined;
  public material: string | undefined;
  public description: string | undefined;
  public manufacturer: string | undefined;
  public manufacturerModel: string | undefined;
  public modelQuantity: string | undefined;
  public modelQuantityDescription: string | undefined;
  public quantity: number | undefined;
  public wasteFactor: string | undefined;
  public quantityToOrder: number | string | undefined;
  public quantityToOrderDescription: string | undefined;
  public parameters: ItemParameterDTO[] | undefined;
  //decimal Cost and total cost
  public cost?: number;
  public totalCost?: number;
 }




 export interface BgBomItemLumber extends BgBomItem {
  lumberLength: number;
 }








export interface CombinedBgBomItem extends BgBomItem {
  comparisonResult?: ComparisonResult; // Define ComparisonResult interface as needed
  combinedQuantityToOrder?: { [key: string]: string }; // Dictionary<string, string> equivalent
}

export enum ComparisonResult {
  Match = 'Match',         // Represents identical elements
  Mismatch = 'Mismatch',   // Represents differences between elements
  Unique = 'Unique'        // Represents an element that is unique (not comparable)
}

export enum BomType {
  Regular = 0,
  Total = 1,
  Addon = 2,
  LumberTotal = 3,
  ChildTotalLumber = 4,
  ChildTotalLumberResidue = 5,
  GypsumBoardTotal = 6,
  GypsumBoard = 7
}


export class ModelSearchRequest {
  public companies: string[] | undefined;
}

export enum ModelAggregationStatus
{
    /// <summary>
    ///  Model is uploaded without any error
    /// </summary>
    Success = 0,
    /// <summary>
    /// You can use this status if the model is uploaded with some not critical errors
    /// But BOM model must show the warning message to the user
    /// </summary>
    Warning = 1,

    /// <summary>
    ///  You can use this status if the model is uploaded with some critical errors
    ///  And BOM model not  anable to show information to the user
    Error = 2
}
